<template>
  <div>
    <div style="margin-bottom: 10px; margin-top: 10px">
      <el-button @click="search()">查询</el-button>
      <el-button size="mini" style="color: #FFFFFF" @click="importExcel()" type="success">导入应出勤天数</el-button>
    </div>

    <div>
      <el-descriptions :column="4" border size="mini">
        <el-descriptions-item label="社保年月">
          <el-date-picker
            v-model="params.month"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="所在项目">
          <el-input size="mini" placeholder="" v-model="params.project_name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="姓名">
          <el-input size="mini" placeholder="请输入姓名" v-model="params.user_name" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="身份证">
          <el-input size="mini" placeholder="身份证" v-model="params.identity_card" clearable></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>


    <div style="margin-top: 10px;">
<!--      <span style="color:red">加载中...</span>-->
    </div>
    <el-table ref="Table" v-if="list" :data="list" height="680px">
      <el-table-column prop="month" width="80" label="应出勤月份" align="center"></el-table-column>
      <el-table-column prop="employee_to" width="200" label="归属" align="center"></el-table-column>
      <el-table-column prop="project" width="200" label="项目" align="center"></el-table-column>
      <el-table-column prop="name"  width="80" label="员工" align="center"></el-table-column>
      <el-table-column prop="identity_card"  width="150" label="身份证" align="center"></el-table-column>
      <el-table-column prop="day"  width="150" label="应出勤天数" align="center"></el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" style="color: #FFFFFF" @click="delRequiredAttendance(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper, sizes"  class="pagination"
                   :total="params.total"
                   :current-page="params.page"
                   :page-size="params.pageSize"
                   :page-sizes="[50, 100, 500]"
                   @current-change="handleCurrentChange" @size-change="handleSizeChange"/>

  </div>
</template>
<script>
import Http from "../common/Http";

export default {
  name: 'RequiredAttendanceList',
  data() {
    return {
      params: {
        month: "",
        project_name: "",
        user_name: "",
        phone: "",
        total: 0,
        page: 1,
        pageSize: 50
      },
      list: []
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted() {
    let date = new Date();
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    this.params.month = date.getFullYear() + '-' + month;
    this.getList()
  },
  methods: {

    search() {
      this.params.page = 1;
      this.getList()
    },
    exportExcel() {

    },
    // 导入execl
    importExcel(type){
      let that=this;
      let upload=document.getElementById("uploadFile-9999");
      if(!upload){
        upload=document.createElement('input');
        upload.type="file";
        upload.id="uploadFile-9999";
        upload.style.display="none";
      }
      upload.click();
      upload.onchange=function (e) {
        let formData = new FormData();
        formData.append("file",this.files[0]);
        formData.append("type",type);
        Http.post(Http.getPreBaseURL()+'/oa/Attendance/importRequiredAttendance',formData,res=>{
          that.$message({type: res.code === 0 ? 'success' : 'error', message: res.msg})
          that.getList()
        })
        upload.onchange=undefined;
      }
    },
    getList() {
      let params = this.params
      Http.get(Http.getPreBaseURL() + '/oa/Attendance/requiredAttendanceList', params, res => {
        if (res.code === 0) {
          this.list = res.data.data;
          this.params.page = res.data.current_page;
          this.params.pageSize = res.data.per_page;
          this.params.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    delRequiredAttendance(id) {
      let params = {id : id};
      Http.get(Http.getPreBaseURL() + '/oa/Attendance/delRequiredAttendance', params, res => {
        if (res.code === 0) {
          this.$message.error({
            message: res.msg,
            type: "success",
          })
          this.getList()
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.params.pageSize = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
$widths: 100px;
.month-table {
  border-color: gray;
  border-collapse: separate;
  user-select: none;
  font-size: 12px;
  min-width: 1200px;
  min-height: 100px;

  tr:hover {
    td.fixed {
      background-color: #dddddd;
      border: 1px solid #ebeef5;
      color: #000;
    }
  }

  th, td {
    min-width: 24px;
    padding: 5px 0px;

    &.fixed {
      position: sticky;
      cursor: pointer;
      z-index: 2;
    }
  }

  th {
    background: #f5f7fa;
    color: #909399;
    border: 1px solid #ebeef5;

    &.hover {
      background-color: #ffebbe;
      color: #333;
    }
  }

  td {
    color: #606266;
    background: #fff;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
    text-align: center;
    overflow: hidden;

    &:first-child {
      border-left: 1px solid #ebeef5;
    }

    &.day-item {
      &.check {
        //background: #fafafa;
        opacity: .5;
      }

      &.changed {
        background: #fd9dca;
        color: #333;
      }

      &.selected {
        background: #409eff;
        color: #409eff;
      }
    }

    &.fixed {
      background-color: #fafafa;
    }

    .work-class-label {
      display: inline-block;
    }
  }

  .department-name {
    box-sizing: border-box;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 78px;
    padding: 0 3px;
    line-height: 20px;
  }

  &.show-department {
    .department-name {
      text-overflow: unset;
      overflow: visible;
      white-space: normal;
      width: 198px;
    }
  }

  .inp {
    box-sizing: border-box;
    width: 100%;
    min-width: 50px;
    text-align: center;
    border: 1px solid #fff;
    outline: none;
    font-size: 12px;
    border-radius: 3px;

    &:hover, &:focus {
      border-color: #ccc;
    }
  }

  .w80 {
    display: inline-block;
    width: 79px;
  }

}

.day-head {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Attendance/RequiredAttendanceList.vue